import { openUrl } from "./link"
import { showDialog } from "./ui"
export const parseResponseButtonApi = function (
  res: any,
  { target = "_blank", autoOpenLink = false, dialogOpts = {} } = {}
) {
  if (res && res.Data) {
    let _data = res.Data
    if (_data.FullPath) {
      if (autoOpenLink === true) {
        openUrl(_data.FullPath, target)
      } else {
        showDialog({
          title: _data.FullPathTitle || "Link",
          ...dialogOpts,
          msg: (
            <div className="msg-api-btn" style={{ wordWrap: "break-word" }}>
              <div>{_data.FullPathInfo}</div>
              <a
                href={_data.FullPath}
                target={target}
                download={_data.FullPathDownload === true ? true : false}
              >
                {_data.FullPath}
              </a>
            </div>
          ),
        })
      }
    }
  }
}
